import cn from 'classnames'

export type TRecordingPlayerProps = {
  url?: string
  compact?: boolean
}

export default function RecordingPlayer({
  url,
  compact,
}: TRecordingPlayerProps): JSX.Element {
  if (!url) {
    return <div>-</div>
  }

  return (
    <div
      className={cn('space-y-2', compact ? 'w-60' : 'w-full')}
      onClick={e => e.stopPropagation()}
    >
      <audio
        className={cn('block h-9', compact ? 'w-60' : 'w-full')}
        controls
        preload='none'
        src={url}
      >
        <a href={url} target='_blank' rel='noreferrer'>
          Open recording
        </a>
      </audio>
      {!compact && (
        <a className='text-blue text-xs' href={url} target='_blank' rel='noreferrer'>
          Download recording
        </a>
      )}
    </div>
  )
}
